/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import type { SerializedStyles } from '@emotion/react';

import * as React from 'react';

import { useCarouselContext } from 'bundles/cds-labs/components/Carousel/Carousel';

const styles = {
  viewport: css`
    overflow: clip;
    width: 100%;
  `,
  container: css`
    display: flex;
    align-items: stretch;
    touch-action: pan-y pinch-zoom;
  `,
};

type Props = {
  className?: string;
  containerClassName?: string;
  containerCss?: SerializedStyles;
};

const CarouselViewport = ({
  children,
  className,
  containerClassName,
  containerCss,
}: React.PropsWithChildren<Props>) => {
  const { emblaRef } = useCarouselContext();

  return (
    <div ref={emblaRef} css={styles.viewport} className={className}>
      <div css={[styles.container, containerCss]} className={containerClassName}>
        {children}
      </div>
    </div>
  );
};

export default CarouselViewport;
